import { CHAT_BUBBLE_ID, CHAT_CONTENT_CONTAINER_ID } from '../constant';

function useScrollChat() {
  const highlightChat = (id) => {
    const bubbleElement = document.getElementById(`${CHAT_BUBBLE_ID}-${id}`);
    bubbleElement.classList.add('chat-highlight');
    setTimeout(() => {
      bubbleElement.classList.remove('chat-highlight');
    }, 3000);
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      const contentElement = document.getElementById(CHAT_CONTENT_CONTAINER_ID);
      if (contentElement) {
        contentElement.scrollTo({
          top: contentElement.scrollHeight,
          behavior: 'smooth',
        });
      }
    }, 50);
  };

  const scrollToChatBubble = (id) => {
    const bubbleId = `${CHAT_BUBBLE_ID}-${id}`;
    const contentElement = document.getElementById(CHAT_CONTENT_CONTAINER_ID);
    const bubbleElement = document.getElementById(bubbleId);
    if (bubbleElement) {
      contentElement.scrollTo({
        top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
        behavior: 'smooth',
      });
      highlightChat(id);
    } else {
      contentElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      setTimeout(() => {
        scrollToChatBubble(id);
      }, 500);
    }
  };

  return {
    scrollToBottom,
    scrollToChatBubble,
    highlightChat,
  };
}

export default useScrollChat;
